/**
 * Product Availability Resolver
 *
 * Given a size, resolves each set product to an available variant
 * using fallback chains. Checks stock first, then preorder.
 *
 * Shared by landing page (stage-set) and ghost cart upsell.
 */
(function(){
  'use strict';

  var SIZE_ORDER = ['XXS','XS','S','M','L','XL','XXL','XXXL'];
  var SIZE_SET = { XXS:1, XS:1, S:1, M:1, L:1, XL:1, XXL:1, XXXL:1 };

  // Extract the SIZE token from a /products.js variant. Colour x Size variants have
  // title "Beige / L" + options ["Beige","L"]; single-option variants have title "L".
  function variantSizeOf(v) {
    if (v.options && v.options.length) {
      for (var i = 0; i < v.options.length; i++) { var o = String(v.options[i]).trim().toUpperCase(); if (SIZE_SET[o]) return o; }
    }
    var t = String(v.title || '').trim();
    if (t.indexOf(' / ') >= 0) { var ps = t.split(' / '); for (var k = 0; k < ps.length; k++) { var pu = ps[k].trim().toUpperCase(); if (SIZE_SET[pu]) return pu; } }
    return t.toUpperCase();
  }

  // Fallback chains per product slot
  // Order matters: primary first, then fallbacks in preference order
  var FALLBACK_CHAINS = {
    // Maternity leggings
    '7-8-mat-pocket-leggings-black': [
      { handle: '7-8-mat-pocket-leggings-black', name: '7/8 Maternity Leggings + Pockets' },
      { handle: 'fl-mat-leggings-pockets-black', name: 'Full Length Maternity Leggings + Pockets' },
      { handle: 'fl-mat-leggings-black', name: 'Full Length Maternity Leggings' },
      { handle: '3-4-mat-leggings-black', name: '3/4 Maternity Leggings' },
    ],
    // Maternity shorts
    'shorts-mat-pocket-black': [
      { handle: 'shorts-mat-pocket-black', name: 'Maternity Shorts + Pockets' },
      { handle: 'shorts-mat-black', name: 'Maternity Shorts' },
      { handle: 'emama-maternity-long-shorts-black', name: 'Maternity Long Shorts' },
    ],
    // Nursing crop
    'emama-longline-crop': [
      { handle: 'emama-longline-crop', name: 'Nursing Crop' },
      { handle: 'long-line-crop-black', name: 'Long Line Crop' },
      { handle: 'long-line-crop-powderblue', name: 'Long Line Crop — Powder Blue' },
      { handle: 'elevate-crop', name: 'Elevate Sports Bra' },
      { handle: 'singlet-top-rose', name: 'Singlet Top — Rose' },
    ],
    // Recovery 7/8 leggings
    'pregnancy-recovery-emama-7-8-leggings-pockets': [
      { handle: 'pregnancy-recovery-emama-7-8-leggings-pockets', name: '7/8 Recovery Leggings + Pockets' },
      { handle: 'pregnancy-recovery-emama-7-8-leggings', name: '7/8 Recovery Leggings' },
      { handle: 'pregnancy-recovery-emama-full-length-leggings-pockets', name: 'Full Length Recovery Leggings + Pockets' },
      { handle: 'recovery', name: 'Full Length Recovery Leggings' },
    ],
    // Recovery shorts
    'pregnancy-recovery-emama-shorts-pockets': [
      { handle: 'pregnancy-recovery-emama-shorts-pockets', name: 'Recovery Shorts + Pockets' },
      { handle: 'pregnancy-recovery-emama-shorts', name: 'Recovery Shorts' },
    ],
    // Shaper move shorts
    'shorts-shaper-move-pockets-black': [
      { handle: 'shorts-shaper-move-pockets-black', name: 'Shaper Move Shorts + Pockets' },
      { handle: 'shorts-shaper-move-black', name: 'Shaper Move Shorts' },
      { handle: 'shaper-move-longer-shorts-pockets-black', name: 'Shaper Move Long Shorts + Pockets' },
    ],
    // 7/8 Shaper move leggings
    '7-8-shaper-move-leggings-pockets-black': [
      { handle: '7-8-shaper-move-leggings-pockets-black', name: '7/8 Shaper Move Leggings + Pockets' },
      { handle: '7-8-shaper-move-leggings-black', name: '7/8 Shaper Move Leggings' },
      { handle: 'fl-shaper-move-leggings-pockets-black', name: 'Full Length Shaper Move Leggings + Pockets' },
      { handle: 'fl-shaper-move-leggings-black', name: 'Full Length Shaper Move Leggings' },
    ],
    // Body shapewear shorts
    'body-shapewear-shorts-pockets': [
      { handle: 'body-shapewear-shorts-pockets', name: 'Body Shapewear Shorts + Pockets' },
      { handle: 'body-shapewear-shorts', name: 'Body Shapewear Shorts' },
    ],
    // Long line crop (mum life)
    'long-line-crop-black': [
      { handle: 'long-line-crop-black', name: 'Long Line Crop' },
      { handle: 'emama-longline-crop', name: 'Nursing Crop' },
      { handle: 'long-line-crop-powderblue', name: 'Long Line Crop — Powder Blue' },
      { handle: 'elevate-crop', name: 'Elevate Sports Bra' },
      { handle: 'singlet-top-rose', name: 'Singlet Top — Rose' },
    ],
  };

  // Known post-partum product handles where the user typically sizes UP.
  // Recovery + nursing products fit this rule.
  var KNOWN_POSTPARTUM_HANDLES = {
    'emama-longline-crop': true,
    'emama-long-line-nursing-crop': true,
    'emama-long-line-nursing-crop-rose': true,
    'sky-blue-crop': true,
    'lilac-emama-crop': true,
    'long-line-crop-black': true,
    'long-line-crop-lilac': true,
    'long-line-crop-powderblue': true,
    'mauve-bella-nursing-crop-long-line-emam': true,
    'emama-black-ribbed-long-sleeve-top-emam': true,
    'nursing-cropped-jumper-grey': true,
    'copy-of-emama-black-long-line-nursing-c': true,
    'copy-of-elevate-nursing-sports-bra-deep': true
  };

  function isPostPartumHandle(handle) {
    if (!handle) return false;
    var h = String(handle).toLowerCase();
    if (h.indexOf('recovery') >= 0) return true;
    if (h.indexOf('nursing') >= 0) return true;
    return !!KNOWN_POSTPARTUM_HANDLES[h];
  }

  function shiftSizeUp(s, amount) {
    var i = SIZE_ORDER.indexOf((s || '').toUpperCase());
    if (i < 0) return s;
    var target = i + (amount || 1);
    if (target >= SIZE_ORDER.length) target = SIZE_ORDER.length - 1;
    return SIZE_ORDER[target];
  }

  // Product data cache: handle -> { variants: [{id, title, sku, available, inventory_quantity}] }
  var productCache = {};
  var preorderSkus = null; // Set of SKUs with preorder qty > 0

  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        var prod = {
          handle: d.handle,
          title: d.title,
          image: d.featured_image,
          variants: d.variants.map(function(v) {
            return {
              id: v.id,
              title: v.title,
              sku: v.sku || '',
              available: v.available,
              inventory_quantity: v.inventory_quantity || 0,
              options: v.options || [],
            };
          })
        };
        productCache[handle] = prod;
        return prod;
      })
      .catch(function() { return null; });
  }

  function loadPreorderConfig(url) {
    if (preorderSkus) return Promise.resolve();
    return fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(cfg) {
        preorderSkus = {};
        if (Array.isArray(cfg)) {
          cfg.forEach(function(entry) {
            if (entry.qty > 0) {
              preorderSkus[entry.sku] = { note: entry.note || 'Made to order', qty: entry.qty };
            }
          });
        }
      })
      .catch(function() { preorderSkus = {}; });
  }

  function isPreorderSku(sku) {
    return preorderSkus && sku && preorderSkus[sku];
  }

  /**
   * Check if a product has a sellable variant in the given size.
   * Returns { variantId, variantTitle, sku, source: 'stock'|'preorder', preorderNote } or null.
   */
  function findSellableVariant(prod, size) {
    if (!prod || !prod.variants) return null;
    var sz = String(size || '').toUpperCase();
    if (!sz) return null;

    // First pass: exact size match, Shopify says available (in stock or continue selling)
    for (var i = 0; i < prod.variants.length; i++) {
      var v = prod.variants[i];
      if (variantSizeOf(v) === sz && v.available) {
        var po = isPreorderSku(v.sku);
        return {
          variantId: v.id, variantTitle: v.title, sku: v.sku,
          source: po ? 'preorder' : 'stock',
          preorderNote: po ? po.note : null,
          handle: prod.handle, name: prod.title, image: prod.image
        };
      }
    }

    // Second pass: exact size match, NOT available on Shopify but IS in preorder config
    // (handles cases where Shopify shows unavailable but preorder system allows purchase)
    for (var i = 0; i < prod.variants.length; i++) {
      var v = prod.variants[i];
      if (variantSizeOf(v) === sz) {
        var po = isPreorderSku(v.sku);
        if (po) {
          return {
            variantId: v.id, variantTitle: v.title, sku: v.sku,
            source: 'preorder', preorderNote: po.note,
            handle: prod.handle, name: prod.title, image: prod.image
          };
        }
      }
    }

    return null;
  }

  /**
   * Resolve a single product slot to a sellable variant.
   * Tries the primary handle, then each fallback in order.
   * For each candidate handle, tries each size in the `sizes` array in order.
   *
   * @param {string} primaryHandle - The preferred product handle
   * @param {string|string[]} sizes - Size(s) to check, in order of preference
   * @param {string} [overrideName] - Display name override
   * @returns {Promise<object|null>} Resolved variant info or null
   */
  function resolveSlot(primaryHandle, sizes, overrideName) {
    var sizeList = Array.isArray(sizes) ? sizes.slice() : [sizes];
    sizeList = sizeList.filter(function(s) { return !!s; });
    if (!sizeList.length) sizeList = ['M'];

    var chain = FALLBACK_CHAINS[primaryHandle];
    if (!chain) chain = [{ handle: primaryHandle, name: overrideName || primaryHandle }];

    var idx = 0;
    function tryNext() {
      if (idx >= chain.length) return Promise.resolve(null);
      var candidate = chain[idx];
      idx++;
      return fetchProduct(candidate.handle).then(function(prod) {
        if (!prod) return tryNext();
        // Try each requested size for this candidate handle
        for (var si = 0; si < sizeList.length; si++) {
          var result = findSellableVariant(prod, sizeList[si]);
          if (result) {
            result.displayName = candidate.name;
            result.wasFallback = idx > 1;
            result.originalHandle = primaryHandle;
            result.resolvedSize = sizeList[si];
            return result;
          }
        }
        return tryNext();
      });
    }
    return tryNext();
  }

  /**
   * Resolve an entire set of products.
   *
   * @param {Array} products - Array of {handle, name, qty, desc, sizes?}
   *                          If a product has its own `sizes` array, it overrides the global.
   * @param {string|string[]|object} sizeOrOptions
   *   - string:   single size for all products (legacy)
   *   - string[]: array of sizes to try in order
   *   - object:   { sizes: string|string[], sizeUpForPostPartum: bool, sizeUpAmount: int }
   * @returns {Promise<Array>} Resolved products with variant info, only sellable items
   */
  function resolveSet(products, sizeOrOptions) {
    var globalSizes = ['M'];
    var sizeUpForPostPartum = false;
    var sizeUpAmount = 1;

    if (typeof sizeOrOptions === 'string') {
      globalSizes = [sizeOrOptions];
    } else if (Array.isArray(sizeOrOptions)) {
      globalSizes = sizeOrOptions.slice();
    } else if (sizeOrOptions && typeof sizeOrOptions === 'object') {
      if (sizeOrOptions.sizes) {
        globalSizes = Array.isArray(sizeOrOptions.sizes) ? sizeOrOptions.sizes.slice() : [sizeOrOptions.sizes];
      }
      sizeUpForPostPartum = !!sizeOrOptions.sizeUpForPostPartum;
      if (typeof sizeOrOptions.sizeUpAmount === 'number') sizeUpAmount = sizeOrOptions.sizeUpAmount;
    }

    var promises = products.map(function(p) {
      // Per-product `sizes` override takes precedence over the global setting
      var sizes = (Array.isArray(p.sizes) && p.sizes.length) ? p.sizes.slice() : globalSizes.slice();
      // Auto size-up for known post-partum products when caller asks for it
      if (sizeUpForPostPartum && isPostPartumHandle(p.handle)) {
        sizes = sizes.map(function(s) { return shiftSizeUp(s, sizeUpAmount); });
      }
      return resolveSlot(p.handle, sizes, p.name).then(function(result) {
        if (!result) return null;
        return {
          handle: result.handle,
          originalHandle: p.handle,
          name: result.displayName || p.name,
          desc: p.desc || '',
          image: result.image || p.image,
          qty: p.qty,
          variantId: result.variantId,
          variantTitle: result.variantTitle,
          sku: result.sku,
          source: result.source,
          preorderNote: result.preorderNote,
          wasFallback: result.wasFallback,
          resolvedSize: result.resolvedSize,
        };
      });
    });

    return Promise.all(promises).then(function(results) {
      return results.filter(Boolean);
    });
  }

  // Export
  window.EmmacoProductResolver = {
    resolveSlot: resolveSlot,
    resolveSet: resolveSet,
    loadPreorderConfig: loadPreorderConfig,
    fetchProduct: fetchProduct,
    isPostPartumHandle: isPostPartumHandle,
    shiftSizeUp: shiftSizeUp,
    getPreorderNote: function(sku) {
      var po = isPreorderSku(sku);
      return po ? po.note : null;
    },
    SIZE_ORDER: SIZE_ORDER,
    FALLBACK_CHAINS: FALLBACK_CHAINS,
  };
})();
